import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { listingsApi as r } from "@maat/api-main";
//#region src/properties/useUpdateListingPricingByIdMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ listingId: e, ...t }) => r.updateListingPricing(e, t),
		onSuccess: (t, { listingId: n }) => {
			i.invalidateQueries({ queryKey: e.listing(n) }), i.invalidateQueries({ queryKey: e.property() }), i.invalidateQueries({ queryKey: e.unit() }), i.invalidateQueries({ queryKey: e.hostFeed() });
		}
	});
};
//#endregion
export { i as useUpdateListingPricingByIdMutation };
